import request from '@/utils/request'
export function page (query) {
    return request({
        url: '/fms/papers/page',
        method: 'get',
        params: query
    })
}
export function creates (data) {
    return request({
        url: '/fms/papers/creates',
        method: 'post',
        data: data,
    })
}
export function update (data) {
    return request({
        url: '/fms/papers/update',
        method: 'post',
        data: data,
    })
}
export function updateSort (data) {
    return request({
        url: '/fms/papers/updateSort',
        method: 'post',
        data: data,
    })
}
export function deleteById (id) {
    return request({
        url: '/fms/papers/deleteById',
        method: 'get',
        params: { id: id }
    })
}
export function deleteByIds (ids) {
    return request({
        url: '/fms/papers/deleteByIds',
        method: 'get',
        params: { ids: ids }
    })
}
export function getById (id) {
    return request({
        url: '/fms/papers/getById',
        method: 'get',
        params: { id: id }
    })
}

//上传文件
export function uploadFile (data, config) {
    return request({
        url: '/fms/file/fileStr',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        ...config
    })
}

//文件下载
export function downloadFile (query) {
    return request({
        url: '/fms/downloadFile',
        method: 'get',
        params: query,
        responseType: 'blob'
    })
}
export function getRoleJSON () {
    return request({
        url: `${process.env.BASE_URL}/static/role.json`,
        params: {
            v: new Date()
        },
        method: 'get',
    })
}
export function deleteFile (data) {
    return request({
        url: '/fms/www/deleteFile',
        method: 'post',
        data: data,
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}


